"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
export default function WhatIsPsychologicalCounseling() {
  return <section id="explanation" className="bg-background pt-0 pb-16 md:pb-24">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-5xl">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center">

          <div className="order-2 lg:order-1">
            <img src="https://yotsuya-sc-room.com/wp-content/uploads/2026/11/desk-explanation.jpg" data-wvc-srcset="https://yotsuya-sc-room.com/wp-content/uploads/2026/11/desk-explanation.jpg-wvc-srcset" data-wvc-sizes="https://yotsuya-sc-room.com/wp-content/uploads/2026/11/desk-explanation.jpg-wvc-sizes" alt="窓際の机と椅子、机上にはランプ・ノート・筆記具・サボテン" className="w-full rounded-lg shadow-lg object-cover object-[75%_center] aspect-[4/3]" loading="lazy" />
          </div>

          <div className="order-1 lg:order-2">
            <span className="inline-block w-fit bg-primary text-primary-foreground text-sm font-bold px-3 py-1 rounded-sm mb-4">心理カウンセリングとは</span>
            <h2 className="text-2xl md:text-3xl font-bold text-foreground font-default leading-tight mb-4">カウンセリングとは？<br className="hidden sm:block" />疑問に少しだけお答えします</h2>
            <Separator className="w-12 h-0.5 bg-primary mb-8" />
            <div className="space-y-6">
              <p className="text-foreground leading-relaxed font-default">だんだんと日本でもカウンセリングが一般的なものになってきたように思います。カウンセリングを行っている場所も増えましたし、SNSなどでは体験談を書いている人もいますので、いろいろなところでカウンセリングを知る機会があります。</p>
              <p className="text-foreground leading-relaxed font-default">ただ、カウンセリングはそれを行っている場所や人によって体験に違いが生まれます。体験談もあくまでその人が感じたことなので、実際にカウンセリングを試してみたらイメージと違ったということもあると思います。</p>
              <p className="text-foreground leading-relaxed font-default">カウンセリングについて満遍なく説明することは難しいですが、こちらのページでは当ルームが行っているカウンセリングについて紹介しています。</p>
            </div>
            <div className="pt-8">
              <Button asChild variant="outline" size="lg" className="border-primary text-primary-heading hover:bg-primary/10 px-8 rounded-lg">
                <Link to="https://yotsuya-sc-room.com/explanation/">心理カウンセリングとは</Link>
              </Button>
            </div>
          </div>

        </div>
      </div>
    </section>;
}